export default __webpack_public_path__ + "static/media/cio-portrait.27fed824.png";